import { TEXTOS } from '../../manual-textos';
import { itensValidos } from '../../manual-utils';
import {
  blocoAlerta,
  blocoCapitulo,
  blocoLista,
  blocoSecao,
  blocoTexto,
} from '../blocos';
import type { Bloco } from '../blocos';
import type { ManualData } from '../../manual-types';
export function capitulo4(dados: ManualData): Bloco[] {
  const blocos: Bloco[] = [blocoCapitulo(4, 'Instalação')];
  blocos.push(...blocoTexto(TEXTOS.aberturaInstalacao, 'c4-abertura'));
  blocos.push(blocoSecao('4.1', 'Transporte'));
  blocos.push(...blocoTexto(dados.transporte || TEXTOS.transporte, 'c4-transporte'));
  blocos.push(blocoSecao('4.2', 'Armazenagem'));
  blocos.push(...blocoTexto(dados.armazenagem || TEXTOS.armazenagem, 'c4-armazenagem'));
  blocos.push(blocoSecao('4.3', 'Montagem e instalação'));
  blocos.push(...blocoTexto(dados.montagem || TEXTOS.instalacao, 'c4-montagem'));
  const requisitos = itensValidos(dados.requisitosLocal, ['texto']).map((item) => item.texto);
  if (requisitos.length) {
    blocos.push(...blocoTexto('O local de instalação deve atender aos requisitos abaixo:', 'c4-requisitos-intro'));
    blocos.push(...blocoLista(requisitos, 'c4-requisitos'));
  }
  blocos.push(blocoSecao('4.4', 'Içamento e elevação'));
  blocos.push(...blocoTexto(dados.icamento || TEXTOS.icamento, 'c4-icamento'));
  blocos.push(blocoAlerta({
    tipo: 'proibido',
    titulo: 'PROIBIDO',
    texto: 'É proibida a permanência ou a circulação de pessoas sob cargas suspensas durante o içamento e a movimentação do equipamento.',
  }, 'c4-alerta-icamento'));
  blocos.push(blocoSecao('4.5', 'Ajustes originais'));
  blocos.push(...blocoTexto(dados.ajustes || TEXTOS.ajustes, 'c4-ajustes'));
  if (dados.opcoes.incluirAssistencia) {
    blocos.push(blocoSecao('4.6', 'Assistência técnica'));
    blocos.push(...blocoTexto(dados.assistencia || TEXTOS.assistencia, 'c4-assistencia'));
    if (dados.assistenciaContato) {
      blocos.push(...blocoTexto(`Contato para assistência técnica: ${dados.assistenciaContato}.`, 'c4-assistencia-contato'));
    }
  }
  return blocos;
}
